import { ticoticketApi } from "../ticoticketApi";
import Cookies from "js-cookie";
import {
  EventData,
  Ticket,
  TicketData,
  TicketValidator,
  CurrentVenueDetail,
  VenueDetails,
  EventDetails,
  CurrentTicketValidatorUser,
} from "../../interfaces/planner.interface";

export const getCategories = async () => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.get("/planner/categories", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error obteniendo los eventos:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const createNewEvent = async (eventData: EventData) => {
  const token = Cookies.get("token");

  const formData = new FormData();
  formData.append("name", eventData.name);
  formData.append("description", eventData.description);
  formData.append("categoryId", eventData.categoryId.toString());
  formData.append("address", eventData.address);
  formData.append("eventId", eventData.id.toString());
  formData.append("startDate", eventData.startDate);
  formData.append("endDate", eventData.endDate);
  formData.append("latitude", eventData.latitude.toString());
  formData.append("longitude", eventData.longitude.toString());
  formData.append("venueDetails", JSON.stringify(eventData.venueDetails)); // Asumiendo que venueDetails es un array o un objeto serializable

  if (eventData.banner.file) {
    formData.append("banner", eventData.banner.file);
  }
  if (eventData.bannerAlt.file) {
    formData.append("bannerAlt", eventData.bannerAlt.file);
  }

  try {
    const { data } = await ticoticketApi.post(
      `/planner/create/event`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error creando el evento:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const getEventsCreated = async () => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.get("/planner/events", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error obteniendo los eventos:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const getSelectedEvent = async (id: number) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.get(`/planner/event/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error obteniendo los eventos:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const getSelectedEventAttendees = async (id: number) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.get(`/planner/event/${id}/attendees`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error obteniendo los eventos:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const createNewTicket = async (ticket: Ticket) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.post(
      `/planner/create/ticket`,
      ticket,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error creando el ticket:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const deleteTicket = async (ticketId: number) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.delete(
      `/planner/delete/ticket/${ticketId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updateTicket = async (
  ticketId: number,
  ticketData: TicketData
) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.put(
      `/planner/update/ticket/${ticketId}`,
      ticketData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updateEventDetails = async (
  updatedFields: EventDetails,
  id: number
) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.put(
      `/planner/update/event-details/${id}`,
      updatedFields,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const createEventVenueDetail = async (venueDetails: VenueDetails) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.post(
      `/planner/create/venue-detail`,
      venueDetails,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const deleteVenueDetail = async (venueId: number) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.delete(
      `/planner/delete/venue-detail/${venueId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updateVenueDetail = async (
  id: number,
  venueDetails: CurrentVenueDetail
) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.put(
      `/planner/update/venue-detail/${id}`,
      venueDetails,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updateBanner = async (
  id: number | undefined,
  formData: FormData
) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.post(
      `/upload/event/${id}/banner`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar el banner:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updateOrganizationLogo = async (formData: FormData) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.post(
      `/upload/planner/logo`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar el banner:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updateBannerAlt = async (
  id: number | undefined,
  formData: FormData
) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.post(
      `/upload/event/${id}/bannerAlt`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar el banner alternativo:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const createTicketValidatorUser = async (
  ticketValidator: TicketValidator
) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.post(
      `/planner/create/ticket-validator`,
      ticketValidator,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error creando el ticket:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const deleteTicketValidatorUser = async (userId: number) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.delete(
      `/planner/delete/ticket-validator/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};

export const updateTicketValidatorUser = async (
  id: number,
  currentTicketValidatorUser: CurrentTicketValidatorUser
) => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.put(
      `/planner/update/ticket-validator/${id}`,
      currentTicketValidatorUser,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error al actualizar los datos del usuario:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};
